module.exports = __webpack_public_path__ + "img/DescontoMenu.abdd6f4e.png";